import { CustomAttributes } from './../constants';
import { Audience } from '../constants';

/**
 * Determines if the user is a member of the signup confidence experiment audience
 * @param cstmAttrs custom attributes for signup experiments
 */
export const isMember = (cstmAttrs: CustomAttributes) => {
  const { hasDoubleFreePlan, isResellerCustomer, isDesktopUser } = cstmAttrs;

  return hasDoubleFreePlan && !isResellerCustomer && isDesktopUser;
};

export const signupConfidenceAudience = {
  isMember,
  id: 'signup_confidence_audience',
  description: `this is the audience that checks the user is signing up with a double free plan,
  is not a reseller customer, and is signing up on a desktop`
} as Audience;

export default {
  signupConfidenceAudience
};
